module.exports = __webpack_public_path__ + "static/media/seatPremierMixed.7470ad9e.png";